import { useFilterDepartmentContext } from "./filter-department.context";

export function FilterDepartment() {
  const { dateFilterElement, reportFilterElements, clearFiltersElement } =
    useFilterDepartmentContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {reportFilterElements}
      {clearFiltersElement}
    </div>
  );
}